<template>
  <div class="select-number">
    <div class="inline">
      <label v-bind:for="id">{{label}}</label>
      <span @click="decrement" class="less">-</span>
      <input
        type="number"
        v-bind:id="id"
        min="0"
        autocomplete="off"
        v-model.number="quantity"
        @focus="focus"
        @focusout="focusOut"
        v-on:input="$emit('change', quantity)"
      >
      <span @click="increment" class="more">+</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {},
    label: {},
    max: {
      type: Number,
      default: null
    },
    propQuantity: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      quantity: this.propQuantity
    };
  },
  methods: {
    // Incrémente la quantité
    increment: function() {
      this.quantity++;
      this.$emit("change", this.quantity);
    },
    // Décrémente la quantité | Uniquement si la quantité est supérieur à 0, pour éviter les nombres négatifs
    decrement: function() {
      if (this.quantity > 0) {
        this.quantity--;
        this.$emit("change", this.quantity);
      }
    },
    // Lorsque l'on focus dans l'input, si la quantité est à 0, elle disparait pour laisser l'utilisateur saisir
    focus: function() {
      if (this.quantity === 0) {
        this.quantity = null;
      }
    },
    // Lorsque l'utilisateur quitte l'input
    focusOut: function() {
      // Si rien n'a été saisie, on remet la quantité à 0
      if (this.quantity === null) {
        this.quantity = 0;
      }

      this.$emit("change", this.quantity);
    }
  }
};
</script>

<style scoped>
.number-button {
  float: left;
  display: block;
  width: 100%;
  height: 35px;
  text-align: center;
  font-size: 100%;
  border: 2px black solid;
  padding: 0.2em;
  line-height: 25px;
}

.less,
.more {
  float: left;
  display: block;
  height: 35px;
  text-align: center;
  font-size: 100%;
  border: 2px black solid;
  padding: 0.2em;
  line-height: 25px;
  width: 20%;
}

.less {
  border-right: 0;
}

.more {
  border-left: 0;
}

input {
  width: 60% !important;
}
</style>
